import React, { useState, useEffect } from "react";
import {
  Modal,
  Button,
  ModalHeader,
  ModalTitle,
  ModalBody,
  ModalFooter,
  Form,
  Tooltip,
  OverlayTrigger,
  Tabs,
  Tab,
  Alert,
} from "react-bootstrap";
import "../styles/style.scss";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle, faLock, faPlus } from "@fortawesome/free-solid-svg-icons";
import QuickUnitCreator from "./QuickUnitCreator";
import VoiceAliasTab from "./VoiceAliasTab";

function Ingredients() {
  const [isLoggedIn, setIsLoggedIn] = useState(true);
  const [inverseConversion, setInverseConversion] = useState(false);

  const handleToggleConversion = () => {
    setInverseConversion(!inverseConversion);
  };

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/isLoggedIn`, {
      credentials: "include",
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.isLoggedIn) {
          setIsLoggedIn(true);
        } else {
          throw new Error("User is not logged in");
        }
      })
      .catch((error) => {
        console.error("Error checking if user is logged in:", error);
        setIsLoggedIn(false);
      });
  }, []);

  // variable for unit options
  const [unitOptions, setUnitOptions] = useState([]);
  const [selectedUnitOption, setSelectedUnitOption] = useState(null);

  // var for shopping options:
  const [shoppingOptions, setShoppingOptions] = useState([]);

  // variables for adding new ingredient:
  const [showNewModal, setShowNewModal] = useState(false);
  const [newIngredientName, setNewIngredientName] = useState("");
  const [newUnitOfMeasurement, setNewUnitOfMeasurement] = useState("");
  const [newUnitOfMeasurementLabel, SetNewUnitOfMeasurementLabel] =
    useState("");
  const [newShoppingAisle, setNewShoppingAisle] = useState("");
  const [newProtein, setNewProtein] = useState("");
  const [newCarbs, setNewCarbs] = useState("");
  const [newFat, setNewFat] = useState("");
  const [newFiber, setNewFiber] = useState("");
  const [newSugar, setNewSugar] = useState("");
  const [newStoreAmount, setNewStoreAmount] = useState("");
  const [newPrice, setNewPrice] = useState("");
  const [newCalculatedPrice, setNewCalculatedPrice] = useState(0);
  const [newCustomUnitFlag, setNewCustomUnitFlag] = useState(0);
  const [newDefaultNeedsPrep, setNewDefaultNeedsPrep] = useState(false);
  const [newDefaultPrepType, setNewDefaultPrepType] = useState('chop');
  const [newPricingUnit, setNewPricingUnit] = useState(null);
  const [newPricingUnitLabel, setNewPricingUnitLabel] = useState("");
  const [showQuickUnitModal, setShowQuickUnitModal] = useState(false);

  // variables for editing ingredient
  const [selectedIngredient, setSelectedIngredient] = useState(null);
  const [editIngredientName, setEditIngredientName] = useState("");
  const [editUnitOfMeasurement, setEditUnitOfMeasurement] = useState("");
  const [editUnitOfMeasurementId, setEditUnitOfMeasurementId] = useState("");
  const [editShoppingAisle, setEditShoppingAisle] = useState("");
  const [editShoppingAisleId, setEditShoppingAisleId] = useState("");
  const [editProtein, setEditProtein] = useState("");
  const [editCarbs, setEditCarbs] = useState("");
  const [editFat, setEditFat] = useState("");
  const [editFiber, setEditFiber] = useState("");
  const [editSugar, setEditSugar] = useState("");
  const [editStoreAmount, setEditStoreAmount] = useState("");
  const [editPrice, setEditPrice] = useState("");
  const [editCalculatedPrice, setEditCalculatedPrice] = useState(0);
  const [editCustomUnitFlag, setEditCustomUnitFlag] = useState(0);
  const [editCustomIngredientFlag, setEditCustomIngredientFlag] = useState(0);
  const [editDefaultNeedsPrep, setEditDefaultNeedsPrep] = useState(false);
  const [editDefaultPrepType, setEditDefaultPrepType] = useState('chop');
  const [ingredientConversionList, setIngredientConversionList] = useState([]);
  const [addConversionInput, setAddConversionInput] = useState("");
  const [editPricingUnit, setEditPricingUnit] = useState(null);
  const [editPricingUnitLabel, setEditPricingUnitLabel] = useState("");

  // variables for table settings (search, sort, paging)
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [sortedColumn, setSortedColumn] = useState("ingredient_name");
  const [sortDirection, setSortDirection] = useState("asc");

  // Variable
  const [selectedIngredientToHide, setSelectedIngredientToHide] =
    useState(null);
  // Variable
  const [selectedIngredientToUnhide, setSelectedIngredientToUnhide] =
    useState(null);
  // Mass update prep flags modal
  const [showMassUpdateModal, setShowMassUpdateModal] = useState(false);
  const [selectedIngredientForMassUpdate, setSelectedIngredientForMassUpdate] = useState(null);
  const [massUpdatePrepValue, setMassUpdatePrepValue] = useState(true);

  // Variables for Editing Conversions
  const [selectedConversionToEdit, setSelectedConversionToEdit] =
    useState(null);
  const [selectedConversionToEditId, setSelectedConversionToEditId] =
    useState(null);
  const [editConversionUnitOfMeasurement, setEditConversionUnitOfMeasurement] =
    useState("");
  const [
    editConversionUnitOfMeasurementId,
    setEditConversionUnitOfMeasurementId,
  ] = useState("");
  const [editConversionCustomUnitFlag, setEditConversionCustomUnitFlag] =
    useState(0);
  const [editConversionFactor, setEditConversionFactor] = useState("");

  const [ingredients, setIngredients] = useState([]);

  const handleHideIngredient = (ingredient) => {
    setSelectedIngredientToHide(ingredient);
  };

  const handleUnhideIngredient = (ingredient) => {
    setSelectedIngredientToUnhide(ingredient);
  };

  const handlePrepFlagToggle = async (ingredient) => {
    const ingredientId = ingredient.id.split(",")[0];
    const isCustom = ingredient.id.toLowerCase().includes("user");
    const newPrepValue = ingredient.default_needs_prep === 1 ? 0 : 1;

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/update-ingredient-prep-flag`,
        {
          method: "PUT",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ingredient_id: ingredientId,
            is_custom: isCustom,
            default_needs_prep: newPrepValue,
            default_prep_type: ingredient.default_prep_type || 'chop',
          }),
        }
      );

      if (response.ok) {
        // Update local state immediately
        setIngredients((prevIngredients) =>
          prevIngredients.map((ing) =>
            ing.id === ingredient.id
              ? { ...ing, default_needs_prep: newPrepValue }
              : ing
          )
        );
        
        // If the mass update modal is for this ingredient, update its value too
        if (selectedIngredientForMassUpdate && selectedIngredientForMassUpdate.id === ingredient.id) {
          setMassUpdatePrepValue(newPrepValue === 1);
        }
      } else {
        console.error("Error updating prep flag");
      }
    } catch (error) {
      console.error("Error updating prep flag:", error);
    }
  };

  const handleMassUpdateClick = (ingredient) => {
    setSelectedIngredientForMassUpdate(ingredient);
    setMassUpdatePrepValue(ingredient.default_needs_prep === 1);
    setShowMassUpdateModal(true);
  };

  const handleMassUpdateConfirm = async () => {
    if (!selectedIngredientForMassUpdate) return;

    const ingredientId = selectedIngredientForMassUpdate.id.split(",")[0];
    const isCustom = selectedIngredientForMassUpdate.id.toLowerCase().includes("user");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/mass-update-recipe-prep-flags`,
        {
          method: "PUT",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ingredient_id: ingredientId,
            is_custom: isCustom,
            needs_prep: massUpdatePrepValue ? 1 : 0,
            prep_type: selectedIngredientForMassUpdate.default_prep_type || 'chop',
          }),
        }
      );

      if (response.ok) {
        const data = await response.json();
        alert(data.message || "Recipes updated successfully");
        setShowMassUpdateModal(false);
      } else {
        console.error("Error mass updating recipes");
        alert("Error updating recipes. Please try again.");
      }
    } catch (error) {
      console.error("Error mass updating recipes:", error);
      alert("Error updating recipes. Please try again.");
    }
  };

  const handleEditConversion = (conversion) => {
    setSelectedConversionToEdit(conversion);
    setSelectedConversionToEditId(conversion.id);
    setEditConversionUnitOfMeasurement(conversion.unit_name);
    setEditConversionUnitOfMeasurementId(conversion.unit_id);
    setEditConversionCustomUnitFlag(conversion.custom_unit);
    setEditConversionFactor(conversion.conversion_factor);
    console.log(conversion);
  };

  // fetch available unit options:
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/units`, {
      credentials: "include",
    })
      .then((response) => response.json())
      .then((data) => setUnitOptions(data))
      .catch((error) => console.error("Error retrieving units:", error));
  }, []);

  // fetch shopping list unit options:
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/shopping_aisle`, {
      credentials: "include",
    })
      .then((response) => response.json())
      .then((data) => setShoppingOptions(data))
      .catch((error) => console.error("Error retrieving units:", error));
  }, []);

  // const handleShoppingChange = (event) => {
  //   setNewShoppingAisle(event.target.value);
  // };

  useEffect(() => {
    // Fetch user units when component is mounted
    fetchIngredients();
  }, []);

  // Add New Unit Modal Show/Hide
  const handleAddClickModal = () => {
    setShowNewModal(true);
  };

  const handleAddCloseModal = () => {
    setShowNewModal(false);
  };

  // Active Table Setup
  //
  // Set up filter
  const filteredIngredients = ingredients.filter((ingredient) =>
    ingredient.ingredient_name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Set up pagnation
  const pagesCount = Math.ceil(filteredIngredients.length / pageSize);
  const startIndex = currentPage * pageSize;
  const endIndex = startIndex + pageSize;

  
  // handle page paging
  const handlePrevPage = () => {
    setCurrentPage((prev) => prev - 1);
  };

  // handle page paging
  const handleNextPage = () => {
    setCurrentPage((prev) => prev + 1);
  };


  // set up sorting
  const sortedUnits = filteredIngredients.sort((a, b) => {
    try {
      if (sortDirection === "asc") {
        return a[sortedColumn].toLowerCase() > b[sortedColumn].toLowerCase()
          ? 1
          : -1;
      } else {
        return a[sortedColumn].toLowerCase() < b[sortedColumn].toLowerCase()
          ? 1
          : -1;
      }
    } catch {}
  });

  // handle sorting
  const handleSort = (columnName) => {
    if (sortedColumn === columnName) {
      // toggle the sort direction if column is already sorted
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      // otherwise, sort by the selected column in ascending order
      setSortedColumn(columnName);
      setSortDirection("asc");
    }
  };

  // Fetch Ingredients for Chart
  const fetchIngredients = () => {
    fetch(`${process.env.REACT_APP_API_URL}/ingredients`, {
      credentials: "include",
    })
      .then((res) => {
        if (!res.ok) {
          if (res.status === 401) {
            console.log("User not authenticated");
            setIngredients([]);
            return;
          }
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        if (data) {
          console.log(data);
          setIngredients(data);
        }
      })
      .catch((err) => {
        console.error("Error retrieving user ingredients:", err);
        setIngredients([]);
      });
  };

  // Helper function to get available pricing units
  const getAvailablePricingUnits = (baseUnitId, baseUnitLabel, conversions = []) => {
    const units = [];
    
    // Add base unit
    if (baseUnitId && baseUnitLabel) {
      units.push({
        unit_id: baseUnitId,
        unit_name: baseUnitLabel,
        conversion_factor: 1,
        is_base: true
      });
    }
    
    // Add conversions
    conversions.forEach(conv => {
      units.push({
        unit_id: conv.unit_id,
        unit_name: conv.unit_name,
        conversion_factor: conv.conversion_factor,
        is_base: false
      });
    });
    
    return units;
  };

  // Add New Unit Handle Form Changes
  const handleNewIngredientNameChange = (event) => {
    setNewIngredientName(event.target.value);
  };

  const calculatePricePerBaseUnit = (price, amount, pricingUnitId, baseUnitId, conversions = ingredientConversionList) => {
    if (!price || !amount) return 0;
    
    let pricePerPricingUnit = price / amount;
    
    // If pricing unit is the base unit, no conversion needed
    if (!pricingUnitId || pricingUnitId === baseUnitId) {
      return pricePerPricingUnit;
    }
    
    // Find the conversion factor from pricing unit to base unit
    const conversion = conversions.find(conv => 
      conv.unit_id === pricingUnitId || 
      conv.default_unit_id === pricingUnitId
    );
    
    if (conversion && conversion.conversion_factor) {
      // The conversion factor tells us how many base units are in 1 pricing unit
      // So we divide the price per pricing unit by the conversion factor
      return pricePerPricingUnit / conversion.conversion_factor;
    }
    
    // If no conversion found, return the direct calculation
    return pricePerPricingUnit;
  };

  const handleNewStoreBaseAmountChange = (event) => {
    const value = event.target.value;
    setNewStoreAmount(value);
    const calculatedPrice = calculatePricePerBaseUnit(
      newPrice, 
      value, 
      newPricingUnit, 
      newUnitOfMeasurement
    );
    setNewCalculatedPrice(calculatedPrice);
  };

  const handleNewStorePriceAmountChange = (event) => {
    const value = event.target.value;
    setNewPrice(value);
    const calculatedPrice = calculatePricePerBaseUnit(
      value, 
      newStoreAmount, 
      newPricingUnit, 
      newUnitOfMeasurement
    );
    setNewCalculatedPrice(calculatedPrice);
  };

  // New Unit Macros:
  const handleNewProteinChange = (newProteinValue) => {
    if (!isNaN(newProteinValue)) {
      setNewProtein(newProteinValue);
    } else {
      setNewProtein(""); // Set a default value
    }
  };

  const handleNewCarbsChange = (newCarbsValue) => {
    if (!isNaN(newCarbsValue)) {
      setNewCarbs(newCarbsValue);
    } else {
      setNewCarbs(""); // Set a default value
    }
  };

  const handleNewFatChange = (newFatValue) => {
    if (!isNaN(newFatValue)) {
      setNewFat(newFatValue);
    } else {
      setNewFat(""); // Set a default value
    }
  };

  const handleNewFiberChange = (newFiberValue) => {
    if (!isNaN(newFiberValue)) {
      setNewFiber(newFiberValue);
    } else {
      setNewFiber(""); // Set a default value
    }
  };

  const handleNewSugarChange = (newSugarValue) => {
    if (!isNaN(newSugarValue)) {
      setNewSugar(newSugarValue);
    } else {
      setNewSugar(""); // Set a default value
    }
  };
  const handleAddIngredient = () => {
    // Check that required fields have a value
    if (!newIngredientName || newIngredientName.trim() === "") {
      alert("Please enter an ingredient name.");
      return;
    }
    if (newIngredientName.trim().length > 100) {
      alert("Ingredient name must be 100 characters or less.");
      return;
    }
    if (!newUnitOfMeasurement) {
      alert("Please select a base unit of measurement for the ingredient.");
      return;
    }
    // Send POST request to add new unit
    fetch(`${process.env.REACT_APP_API_URL}/add-ingredient`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ingredientName: newIngredientName.trim(),
        unitOfMeasurement: newUnitOfMeasurement,
        customUnitFlag: newCustomUnitFlag,
        shoppingAisleId: newShoppingAisle,
        protein: newProtein,
        carbs: newCarbs,
        fat: newFat,
        fiber: newFiber,
        sugar: newSugar,
        price: newCalculatedPrice,
        storePrice: newPrice,
        storeAmount: newStoreAmount,
        defaultNeedsPrep: newDefaultNeedsPrep,
        defaultPrepType: newDefaultPrepType,
      }),
    })
      .then((res) => {
        if (res.ok) {
          // Parse the JSON response
          return res.json();
        } else {
          return res.text().then(text => {
            throw new Error(text || "Error adding new ingredient");
          });
        }
      })
      .then((resultIngredient) => {
        // Set variables based on the ingredient data
        // Assuming ingredient contains properties such as id, name, unitOfMeasurement, etc.

        // Set your variables with the retrieved values
        // Example:
        console.log(resultIngredient[0]);
        setSelectedIngredient(resultIngredient[0]);
        setEditIngredientName(resultIngredient[0].ingredient_name);
        setEditUnitOfMeasurement(resultIngredient[0].unit_id);
        setEditUnitOfMeasurementId(resultIngredient[0].default_unit_id);
        setEditShoppingAisle(resultIngredient[0].shopping_aisle);
        setEditShoppingAisleId(resultIngredient[0].custom_shopping_aisle_id);
        setEditProtein(resultIngredient[0].protein);
        setEditCarbs(resultIngredient[0].carbs);
        setEditFat(resultIngredient[0].fat);
        setEditFiber(resultIngredient[0].fiber);
        setEditSugar(resultIngredient[0].sugar);
        setEditStoreAmount(resultIngredient[0].store_amount);
        setEditPrice(resultIngredient[0].store_price);
        setEditCalculatedPrice(resultIngredient[0].price);
        setEditCustomUnitFlag(resultIngredient[0].custom_unit);

        // Reload units data
        fetchIngredients();
        setNewIngredientName("");
        setNewUnitOfMeasurement("");
        SetNewUnitOfMeasurementLabel("");
        setNewShoppingAisle("");
        setNewProtein("");
        setNewCarbs("");
        setNewFat("");
        setNewFiber("");
        setNewSugar("");
        setNewStoreAmount("");
        setNewPrice("");
        setNewCalculatedPrice(0);
        setNewCustomUnitFlag(0);
        setNewDefaultNeedsPrep(false);
        setNewDefaultPrepType('chop');
        handleAddCloseModal();
      })
      .catch((err) => {
        console.error("Error adding new ingredient:", err);
        alert(err.message || "Failed to add ingredient. Please try again.");
      });
  };

  //
  // Editing Units
  //

  const handleAddConversionInput = (newConversionValue) => {
    if (!isNaN(newConversionValue)) {
      setAddConversionInput(newConversionValue);
    } else {
      setAddConversionInput(""); // Set a default value
    }
  };
  
  const handleEditConversionInput = (newConversionValue) => {
    if (!isNaN(newConversionValue)) {
      setEditConversionFactor(newConversionValue);
    } else {
      setEditConversionFactor(""); // Set a default value
    }
  };
  
  // Funciton to Fetch Unit Converions of the Selected Ingredient
  const fetchIngredientConversions = async (id) => {
    // Determine custom_ingredient flag
    const customIngredientFlag = id.includes("user") ? 1 : 0;

    const ingredientId = id.split(",")[0];

    // Make API call to retrieve unit conversions
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/ingredient-conversions/${ingredientId}?custom_ingredient=${customIngredientFlag}`,
      {
        credentials: "include",
      }
    );

    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      console.error(response.statusText);
      return [];
    }
  };

  const handleSelectIngredient = async (ingredient) => {
    console.log(ingredient);
    setSelectedIngredient(ingredient);
    setEditIngredientName(ingredient.ingredient_name);
    setEditUnitOfMeasurement(ingredient.unit_id);
    setEditUnitOfMeasurementId(ingredient.default_unit_id);
    setEditShoppingAisle(ingredient.shopping_aisle);
    setEditShoppingAisleId(ingredient.custom_shopping_aisle_id);
    setEditProtein(ingredient.protein);
    setEditCarbs(ingredient.carbs);
    setEditFat(ingredient.fat);
    setEditFiber(ingredient.fiber);
    setEditSugar(ingredient.sugar);
    setEditStoreAmount(ingredient.store_amount);
    setEditPrice(ingredient.store_price);
    setEditCalculatedPrice(ingredient.price);
    setEditDefaultNeedsPrep(ingredient.default_needs_prep === 1);
    setEditDefaultPrepType(ingredient.default_prep_type || 'chop');
    setEditCustomUnitFlag(ingredient.custom_unit);
    
    // Set pricing unit to base unit by default
    setEditPricingUnit(ingredient.default_unit_id);
    setEditPricingUnitLabel(ingredient.unit_id);

    const data = await fetchIngredientConversions(ingredient.id);
    setIngredientConversionList(data);
  };

  // Add Edit Unit Handle Form Changes
  const handleEditIngredientNameChange = (event) => {
    setEditIngredientName(event.target.value);
  };

  const handleEditStoreBaseAmountChange = (event) => {
    const value = event.target.value;
    setEditStoreAmount(value);
    const calculatedPrice = calculatePricePerBaseUnit(
      editPrice, 
      value, 
      editPricingUnit, 
      editUnitOfMeasurementId
    );
    setEditCalculatedPrice(calculatedPrice);
  };

  const handleEditStorePriceAmountChange = (event) => {
    const value = event.target.value;
    setEditPrice(value);
    const calculatedPrice = calculatePricePerBaseUnit(
      value, 
      editStoreAmount, 
      editPricingUnit, 
      editUnitOfMeasurementId
    );
    setEditCalculatedPrice(calculatedPrice);
  };

  // Edit Unit Macros:
  const handleEditProteinChange = (newProteinValue) => {
    if (!isNaN(newProteinValue)) {
      setEditProtein(newProteinValue);
    } else {
      setEditProtein(""); // Set a default value
    }
  };

  const handleEditCarbsChange = (newCarbsValue) => {
    if (!isNaN(newCarbsValue)) {
      setEditCarbs(newCarbsValue);
    } else {
      setEditCarbs(""); // Set a default value
    }
  };

  const handleEditFatChange = (newFatValue) => {
    if (!isNaN(newFatValue)) {
      setEditFat(newFatValue);
    } else {
      setEditFat(""); // Set a default value
    }
  };

  const handleEditFiberChange = (newFiberValue) => {
    if (!isNaN(newFiberValue)) {
      setEditFiber(newFiberValue);
    } else {
      setEditFiber(""); // Set a default value
    }
  };

  const handleEditSugarChange = (newSugarValue) => {
    if (!isNaN(newSugarValue)) {
      setEditSugar(newSugarValue);
    } else {
      setEditSugar(""); // Set a default value
    }
  };

  const handleSaveIngredient = () => {
    if (selectedIngredient.id.includes("user")) {
      const id = selectedIngredient.id.split(",")[0];
      // This is a user ingredient, send PUT request to backend
      fetch(`${process.env.REACT_APP_API_URL}/edit-ingredient?id=${id}`, {
        method: "PUT",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: id,
          ingredientName: editIngredientName.trim(),
          unitOfMeasurement: editUnitOfMeasurementId,
          customUnitFlag: editCustomUnitFlag,
          shoppingAisleId: editShoppingAisleId,
          protein: editProtein,
          carbs: editCarbs,
          fat: editFat,
          fiber: editFiber,
          sugar: editSugar,
          price: editCalculatedPrice,
          storePrice: editPrice,
          storeAmount: editStoreAmount,
          defaultNeedsPrep: editDefaultNeedsPrep,
          defaultPrepType: editDefaultPrepType,
        }),
      })
        .then((res) => {
          if (res.ok) {
            // Reload ingredients data
            fetchIngredients();
            fetchHiddenIngredients();
            setSelectedIngredient(null);
            setEditIngredientName("");
            setEditUnitOfMeasurement("");
            setEditUnitOfMeasurementId("");
            setEditShoppingAisle("");
            setEditShoppingAisleId("");
            setEditProtein("");
            setEditCarbs("");
            setEditFat("");
            setEditFiber("");
            setEditSugar("");
            setEditStoreAmount("");
            setEditPrice("");
            setEditCalculatedPrice(0);
            setEditCustomUnitFlag(0);
          } else {
            throw new Error("Error updating ingredient");
          }
        })
        .catch((err) => {
          console.error("Error updating ingredient:", err);
        });
    } else {
      const id = selectedIngredient.id.split(",")[0];
      // This is not a user ingredient, query user_ingredient_customizations table
      const url = `${process.env.REACT_APP_API_URL}/user-ingredient-customization?ingredient_id=${id}`;
      fetch(url, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("Error querying user ingredient customization");
          }
        })
        .then((data) => {
          console.log(data);
          try {
            if (data.length === 0) {
              // No match, create new entry in user_ingredient_customizations table
              fetch(
                `${process.env.REACT_APP_API_URL}/user-ingredient-customization`,
                {
                  method: "POST",
                  credentials: "include",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    id: id,
                    shoppingAisleId: editShoppingAisleId,
                    price: editCalculatedPrice,
                    storePrice: editPrice,
                    storeAmount: editStoreAmount,
                    defaultNeedsPrep: editDefaultNeedsPrep,
                    defaultPrepType: editDefaultPrepType,
                  }),
                }
              )
                .then((res) => {
                  if (res.ok) {
                    // Reload ingredients data
                    fetchIngredients();
                    fetchHiddenIngredients();
                    setSelectedIngredient(null);
                    setEditIngredientName("");
                    setEditUnitOfMeasurement("");
                    setEditUnitOfMeasurementId("");
                    setEditShoppingAisle("");
                    setEditShoppingAisleId("");
                    setEditProtein("");
                    setEditCarbs("");
                    setEditFat("");
                    setEditFiber("");
                    setEditSugar("");
                    setEditStoreAmount("");
                    setEditPrice("");
                    setEditCalculatedPrice(0);
                    setEditCustomUnitFlag(0);
                  } else {
                    throw new Error(
                      "Error creating user ingredient customization"
                    );
                  }
                })
                .catch((err) => {
                  console.error(
                    "Error creating user ingredient customization:",
                    err
                  );
                });
            } else {
              // Match found, update existing entry in user_ingredient_customizations table
              fetch(
                `${process.env.REACT_APP_API_URL}/user-ingredient-customization/${data[0].id}`,
                {
                  method: "PUT",
                  credentials: "include",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    id: id,
                    shoppingAisleId: editShoppingAisleId,
                    price: editCalculatedPrice,
                    storePrice: editPrice,
                    storeAmount: editStoreAmount,
                    defaultNeedsPrep: editDefaultNeedsPrep,
                    defaultPrepType: editDefaultPrepType,
                  }),
                }
              )
                .then((res) => {
                  if (res.ok) {
                    // Reload ingredients data
                    fetchIngredients();
                    fetchHiddenIngredients();
                    setSelectedIngredient(null);
                    setEditIngredientName("");
                    setEditUnitOfMeasurement("");
                    setEditUnitOfMeasurementId("");
                    setEditShoppingAisle("");
                    setEditShoppingAisleId("");
                    setEditProtein("");
                    setEditCarbs("");
                    setEditFat("");
                    setEditFiber("");
                    setEditSugar("");
                    setEditStoreAmount("");
                    setEditPrice("");
                    setEditCalculatedPrice(0);
                    setEditCustomUnitFlag(0);
                  } else {
                    throw new Error(
                      "Error updating user ingredient customization"
                    );
                  }
                })
                .catch((err) => {
                  console.error(
                    "Error updating user ingredient customization:",
                    err
                  );
                });
            }
          } catch (err) {
            console.error("Error parsing JSON response:", err);
          }
        })
        .catch((err) => {
          console.error("Error querying user ingredient customization:", err);
        });
    }
  };

  const handleAddUnitConversion = () => {
    if (!addConversionInput) {
      alert("Please add a conversion qty.");
      return;
    }
    const conversionFactor = inverseConversion
      ? 1 / addConversionInput
      : addConversionInput;

    const customIngredientFlag = selectedIngredient.id.includes("user") ? 1 : 0;
    const ingredientId = selectedIngredient.id.split(",")[0];

    // Check for existing unit conversion
    fetch(
      `${process.env.REACT_APP_API_URL}/api/check-unit-conversion?ingredientId=${ingredientId}&newUnitOfMeasurement=${newUnitOfMeasurement}&newCustomUnitFlag=${newCustomUnitFlag}&customIngredientFlag=${customIngredientFlag}`,
      {
        credentials: "include",
      }
    )
      .then((response) => {
        if (response.ok) {
          // No existing conversion found, continue with adding a new conversion
          return fetch(
            `${process.env.REACT_APP_API_URL}/api/add-unit-conversion`,
            {
              method: "POST",
              credentials: "include",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                customIngredientFlag: customIngredientFlag,
                ingredientId: ingredientId,
                newUnitOfMeasurement: newUnitOfMeasurement,
                newCustomUnitFlag: newCustomUnitFlag,
                addConversionInput: conversionFactor,
              }),
            }
          );
        } else {
          // Existing conversion found, display error message
          const error =
            "Duplicate Entry - You already have an existing conversion for this unit";
          throw new Error(error);
        }
      })
      .then((response) => response.json())
      .then((data) => {
        //Fetch the updated ingredient conversions after successful addition
        fetchIngredientConversions(selectedIngredient.id)
          .then((data) => setIngredientConversionList(data))
          .catch((error) => console.error(error));
        //Clear the addConversionInput field
        setAddConversionInput("");
      })
      .catch((error) => {
        console.error(error.message);
        alert(error.message);
      });
  };

  // Update Unit Conversion
  const handleUpdateUnitConversion = async () => {
    try {
      const conversionFactor = inverseConversion
      ? 1 / editConversionFactor
      : editConversionFactor;

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/conversions/${selectedConversionToEditId}`,
        {
          method: "PUT",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            unit_id: editConversionUnitOfMeasurementId,
            custom_unit: editConversionCustomUnitFlag,
            conversion_factor: conversionFactor,
          }),
        }
      );

      if (!response.ok) {
        throw new Error(response.statusText);
      }

      // Update the state with the new values
      setSelectedConversionToEdit({
        id: selectedConversionToEditId,
        unit_id: editConversionUnitOfMeasurementId,
        custom_unit: editConversionCustomUnitFlag,
        conversion_factor: editConversionFactor,
      });

      // Clear the form fields
      fetchIngredientConversions(selectedIngredient.id)
        .then((data) => setIngredientConversionList(data))
        .catch((error) => console.error(error));
      setSelectedConversionToEdit(null);
      setEditConversionUnitOfMeasurement("");
      setEditConversionUnitOfMeasurementId("");
      setEditConversionCustomUnitFlag(0);
      setEditConversionFactor("");
    } catch (error) {
      console.error(error);
    }
  };

  // Handle Delete Conversion
  const handleDeleteConversion = async (conversion) => {
    const confirmed = window.confirm(
      `Are you sure you want to delete the conversion "${conversion.unit_name}"?`
    );

    if (!confirmed) return;

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/conversions/delete/${conversion.id}`,
        {
          method: "DELETE",
        }
      );

      if (!response.ok) {
        throw new Error(response.statusText);
      }

      // Remove the deleted conversion from the ingredientConversionList state
      fetchIngredientConversions(selectedIngredient.id)
        .then((data) => setIngredientConversionList(data))
        .catch((error) => console.error(error));
    } catch (error) {
      console.error(error);
    }
  };
  //hide unit
  const handleConfirmHideIngredient = async () => {
    if (selectedIngredientToHide.id.includes("user")) {
      const id = selectedIngredientToHide.id.split(",")[0];
      // This is a user ingredient, send PUT request to backend
      fetch(`${process.env.REACT_APP_API_URL}/user/hide-ingredient?id=${id}`, {
        method: "PUT",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: id,
          display: 0,
        }),
      })
        .then((res) => {
          if (res.ok) {
            // Reload ingredients data
            setSelectedIngredientToHide(null);
            // Reload your table data here to reflect the updated display status
            fetchIngredients();
            fetchHiddenIngredients();
          } else {
            throw new Error("Error updating ingredient");
          }
        })
        .catch((err) => {
          console.error("Error updating ingredient:", err);
        });
    } else {
      const id = selectedIngredientToHide.id.split(",")[0];
      // This is not a user ingredient, query user_ingredient_customizations table
      const url = `${process.env.REACT_APP_API_URL}/user-ingredient-customization?ingredient_id=${id}`;
      fetch(url, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("Error querying user ingredient customization");
          }
        })
        .then((data) => {
          console.log(data);
          try {
            if (data.length === 0) {
              // No match, create new entry in user_ingredient_customizations table
              fetch(
                `${process.env.REACT_APP_API_URL}/default/new-hide-ingredient?id=${id}`,
                {
                  method: "POST",
                  credentials: "include",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    id: id,
                    display: 0,
                  }),
                }
              )
                .then((res) => {
                  if (res.ok) {
                    // Reload ingredients data
                    // Reload ingredients data
                    setSelectedIngredientToHide(null);
                    // Reload your table data here to reflect the updated display status
                    fetchIngredients();
                    fetchHiddenIngredients();
                  } else {
                    throw new Error(
                      "Error creating user ingredient customization"
                    );
                  }
                })
                .catch((err) => {
                  console.error(
                    "Error creating user ingredient customization:",
                    err
                  );
                });
            } else {
              // Match found, update existing entry in user_ingredient_customizations table
              console.log(data[0].id);
              fetch(
                `${process.env.REACT_APP_API_URL}/default/hide-ingredient/${data[0].id}`,
                {
                  method: "PUT",
                  credentials: "include",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    id: id,
                    display: 0,
                  }),
                }
              )
                .then((res) => {
                  if (res.ok) {
                    // Reload ingredients data
                    // Reload ingredients data
                    setSelectedIngredientToHide(null);
                    // Reload your table data here to reflect the updated display status
                    fetchIngredients();
                    fetchHiddenIngredients();
                  } else {
                    throw new Error(
                      "Error updating user ingredient customization"
                    );
                  }
                })
                .catch((err) => {
                  console.error(
                    "Error updating user ingredient customization:",
                    err
                  );
                });
            }
          } catch (err) {
            console.error("Error parsing JSON response:", err);
          }
        })
        .catch((err) => {
          console.error("Error querying user ingredient customization:", err);
        });
    }
  };

  //UNHIDE unit
  const handleConfirmUnhideIngredient = async () => {
    if (selectedIngredientToUnhide.id.includes("user")) {
      const id = selectedIngredientToUnhide.id.split(",")[0];
      // This is a user ingredient, send PUT request to backend
      fetch(
        `${process.env.REACT_APP_API_URL}/user/unhide-ingredient?id=${id}`,
        {
          method: "PUT",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: id,
            display: 1,
          }),
        }
      )
        .then((res) => {
          if (res.ok) {
            // Reload ingredients data
            setSelectedIngredientToUnhide(null);
            // Reload your table data here to reflect the updated display status
            fetchIngredients();
            fetchHiddenIngredients();
          } else {
            throw new Error("Error updating ingredient");
          }
        })
        .catch((err) => {
          console.error("Error updating ingredient:", err);
        });
    } else {
      const id = selectedIngredientToUnhide.id.split(",")[0];
      // This is not a user ingredient, query user_ingredient_customizations table
      const url = `${process.env.REACT_APP_API_URL}/user-ingredient-customization?ingredient_id=${id}`;
      fetch(url, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("Error querying user ingredient customization");
          }
        })
        .then((data) => {
          console.log(data);
          try {
            if (data.length === 0) {
              // No match, create new entry in user_ingredient_customizations table
              fetch(
                `${process.env.REACT_APP_API_URL}/default/new-unhide-ingredient?id=${id}`,
                {
                  method: "POST",
                  credentials: "include",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    id: id,
                    display: 1,
                  }),
                }
              )
                .then((res) => {
                  if (res.ok) {
                    // Reload ingredients data
                    // Reload ingredients data
                    setSelectedIngredientToUnhide(null);
                    // Reload your table data here to reflect the updated display status
                    fetchIngredients();
                    fetchHiddenIngredients();
                  } else {
                    throw new Error(
                      "Error creating user ingredient customization"
                    );
                  }
                })
                .catch((err) => {
                  console.error(
                    "Error creating user ingredient customization:",
                    err
                  );
                });
            } else {
              // Match found, update existing entry in user_ingredient_customizations table
              console.log(data[0].id);
              fetch(
                `${process.env.REACT_APP_API_URL}/default/unhide-ingredient/${data[0].id}`,
                {
                  method: "PUT",
                  credentials: "include",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    id: id,
                    display: 1,
                  }),
                }
              )
                .then((res) => {
                  if (res.ok) {
                    // Reload ingredients data
                    // Reload ingredients data
                    setSelectedIngredientToUnhide(null);
                    // Reload your table data here to reflect the updated display status
                    fetchIngredients();
                    fetchHiddenIngredients();
                  } else {
                    throw new Error(
                      "Error updating user ingredient customization"
                    );
                  }
                })
                .catch((err) => {
                  console.error(
                    "Error updating user ingredient customization:",
                    err
                  );
                });
            }
          } catch (err) {
            console.error("Error parsing JSON response:", err);
          }
        })
        .catch((err) => {
          console.error("Error querying user ingredient customization:", err);
        });
    }
  };

  // Hidden Units Only
  const [hiddenIngredients, setHiddenIngredients] = useState([]);

  const [hiddenSearchQuery, setHiddenSearchQuery] = useState("");
  const [hiddenCurrentPage, setHiddenCurrentPage] = useState(0);
  const [hiddenPageSize, setHiddenPageSize] = useState(25);
  const [hiddenSortedColumn, setHiddenSortedColumn] = useState("unit_name");
  const [hiddenSortDirection, setHiddenSortDirection] = useState("asc");
  const [selectedUnitToUnHide, setSelectedUnitToUnHide] = useState(null);

  const hiddenFilteredIngredients = hiddenIngredients.filter((hiddenUnit) =>
    hiddenUnit.ingredient_name
      .toLowerCase()
      .includes(hiddenSearchQuery.toLowerCase())
  );

  const hiddenPagesCount = Math.ceil(
    hiddenFilteredIngredients.length / hiddenPageSize
  );
  const hiddenStartIndex = hiddenCurrentPage * hiddenPageSize;
  const hiddenEndIndex = hiddenStartIndex + hiddenPageSize;

  const hiddenHandlePrevPage = () => {
    setHiddenCurrentPage((prev) => prev - 1);
  };

  const hiddenHandleNextPage = () => {
    setHiddenCurrentPage((prev) => prev + 1);
  };

  const hiddenSortedUnits = hiddenFilteredIngredients.sort((a, b) => {
    try {
      if (hiddenSortDirection === "asc") {
        return a[hiddenSortedColumn].toLowerCase() >
          b[hiddenSortedColumn].toLowerCase()
          ? 1
          : -1;
      } else {
        return a[hiddenSortedColumn].toLowerCase() <
          b[hiddenSortedColumn].toLowerCase()
          ? 1
          : -1;
      }
    } catch {}
  });

  const hiddenHandleSort = (columnName) => {
    if (hiddenSortedColumn === columnName) {
      // toggle the sort direction if column is already sorted
      setHiddenSortDirection(hiddenSortDirection === "asc" ? "desc" : "asc");
    } else {
      // otherwise, sort by the selected column in ascending order
      setHiddenSortedColumn(columnName);
      setHiddenSortDirection("asc");
    }
  };



  // Fetch Ingredients for Chart
  const fetchHiddenIngredients = () => {
    fetch(`${process.env.REACT_APP_API_URL}/hidden-ingredients`, {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setHiddenIngredients(data);
      })
      .catch((err) => {
        console.error("Error retrieving user ingredients:", err);
      });
  };

  useEffect(() => {
    // Fetch user units when component is mounted
    fetchIngredients();
    fetchHiddenIngredients();
  }, []);

  if (!isLoggedIn) {
    return (
      <h3>
        Please{" "}
        <a
          className="btn btn-primary"
          href={`/signin?returnUrl=${encodeURIComponent(
            window.location.pathname
          )}`}
        >
          Sign In
        </a>{" "}
        to view
      </h3>
    );
  }

  return (
    <div>
      <div>
        <h2>Add Ingredient</h2>
        <div className="mb-3 col-sm-4">
          <button
            className="btn btn-secondary mt-2"
            onClick={handleAddClickModal}
          >
            Add Ingredient
          </button>
        </div>
        <div className="mb-3 col-6">
          <h2>Active Ingredients</h2>
          <p>(D) = Default Ingredients</p>
        </div>

        <div>
          <div className="row">
            <div className="col-sm-4 ">
              <label htmlFor="page-size-select" className="mr-2">
                Show:
              </label>{" "}
              <div className="btn-group mr-2">
                <button
                  type="button"
                  className="btn btn-sm btn-secondary dropdown-toggle"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  {pageSize}
                </button>
                <div className="dropdown-menu">
                  <button
                    className="dropdown-item"
                    onClick={() => setPageSize(10)}
                  >
                    10
                  </button>
                  <button
                    className="dropdown-item"
                    onClick={() => setPageSize(25)}
                  >
                    25
                  </button>
                  <button
                    className="dropdown-item"
                    onClick={() => setPageSize(50)}
                  >
                    50
                  </button>
                  <button
                    className="dropdown-item"
                    onClick={() => setPageSize(100)}
                  >
                    100
                  </button>
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <input
                type="text"
                className="form-control"
                placeholder="Search units"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
            <div className="col-sm-4">
  <nav>
    <ul className="pagination justify-content-end">
      <li className={`page-item ${currentPage === 0 && "disabled"}`}>
        <button
          className="page-link"
          onClick={handlePrevPage}
          disabled={currentPage === 0}
        >
          Previous
        </button>
      </li>
      {Array.from({ length: pagesCount }, (_, i) => {
        // Display only a subset of pages around the current page
        const maxPagesToShow = 5; // Adjust as needed
        const halfMaxPagesToShow = Math.floor(maxPagesToShow / 2);
        const startPage =
          currentPage <= halfMaxPagesToShow
            ? 0
            : Math.min(
                Math.max(currentPage - halfMaxPagesToShow, 0),
                pagesCount - maxPagesToShow
              );
        const endPage = Math.min(startPage + maxPagesToShow, pagesCount);

        if (i === startPage && startPage !== 0) {
          return (
            <li key="ellipsis-start" className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          );
        }

        if (i === endPage && endPage !== pagesCount) {
          return (
            <li key="ellipsis-end" className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          );
        }

        if (i >= startPage && i < endPage) {
          return (
            <li
              key={i}
              className={`page-item ${currentPage === i && "active"}`}
            >
              <button
                className="page-link"
                onClick={() => setCurrentPage(i)}
              >
                {i + 1}
              </button>
            </li>
          );
        }

        return null;
      })}
      <li
        className={`page-item ${
          currentPage === pagesCount - 1 && "disabled"
        }`}
      >
        <button
          className="page-link"
          onClick={handleNextPage}
          disabled={currentPage === pagesCount - 1}
        >
          Next
        </button>
      </li>
    </ul>
  </nav>
</div>
          </div>
          <div className="table-responsive">
            <table className="table table-hover table-bordered table-striped">
              <thead>
                <tr>
                  <th
                    className="text-center clickable"
                    title="Click to sort"
                    onClick={() => handleSort("ingredient_name")}
                  >
                    Ingredient{" "}
                    {sortedColumn === "ingredient_name" && (
                      <i
                        className={`fas fa-chevron-${
                          sortDirection === "asc" ? "up" : "down"
                        }`}
                      />
                    )}
                    {sortedColumn !== "ingredient_name" && (
                      <i className="fas fa-chevron-down fa-opac" />
                    )}
                  </th>
                  <th
                    className="text-center clickable"
                    title="Click to sort"
                    onClick={() => handleSort("unit_id")}
                  >
                    Base Unit{" "}
                    {sortedColumn === "unit_id" && (
                      <i
                        className={`fas fa-chevron-${
                          sortDirection === "asc" ? "up" : "down"
                        }`}
                      />
                    )}
                    {sortedColumn !== "unit_id" && (
                      <i className="fas fa-chevron-down fa-opac" />
                    )}
                  </th>
                  <th
                    className="text-center clickable"
                    title="Click to sort"
                    onClick={() => handleSort("calories")}
                  >
                    Calories{" "}
                    {sortedColumn === "calories" && (
                      <i
                        className={`fas fa-chevron-${
                          sortDirection === "asc" ? "up" : "down"
                        }`}
                      />
                    )}
                    {sortedColumn !== "calories" && (
                      <i className="fas fa-chevron-down fa-opac" />
                    )}
                  </th>
                  <th
                    className="text-center clickable"
                    title="Click to sort"
                    onClick={() => handleSort("protein")}
                  >
                    Protein{" "}
                    {sortedColumn === "protein" && (
                      <i
                        className={`fas fa-chevron-${
                          sortDirection === "asc" ? "up" : "down"
                        }`}
                      />
                    )}
                    {sortedColumn !== "protein" && (
                      <i className="fas fa-chevron-down fa-opac" />
                    )}
                  </th>
                  <th
                    className="text-center clickable"
                    title="Click to sort"
                    onClick={() => handleSort("carbs")}
                  >
                    Carbs{" "}
                    {sortedColumn === "carbs" && (
                      <i
                        className={`fas fa-chevron-${
                          sortDirection === "asc" ? "up" : "down"
                        }`}
                      />
                    )}
                    {sortedColumn !== "carbs" && (
                      <i className="fas fa-chevron-down fa-opac" />
                    )}
                  </th>
                  <th
                    className="text-center clickable"
                    title="Click to sort"
                    onClick={() => handleSort("fat")}
                  >
                    Fat{" "}
                    {sortedColumn === "fat" && (
                      <i
                        className={`fas fa-chevron-${
                          sortDirection === "asc" ? "up" : "down"
                        }`}
                      />
                    )}
                    {sortedColumn !== "fat" && (
                      <i className="fas fa-chevron-down fa-opac" />
                    )}
                  </th>
                  <th
                    className="text-center clickable"
                    title="Click to sort"
                    onClick={() => handleSort("fiber")}
                  >
                    Fiber{" "}
                    {sortedColumn === "fiber" && (
                      <i
                        className={`fas fa-chevron-${
                          sortDirection === "asc" ? "up" : "down"
                        }`}
                      />
                    )}
                    {sortedColumn !== "fiber" && (
                      <i className="fas fa-chevron-down fa-opac" />
                    )}
                  </th>
                  <th
                    className="text-center clickable"
                    title="Click to sort"
                    onClick={() => handleSort("sugar")}
                  >
                    Sugar{" "}
                    {sortedColumn === "sugar" && (
                      <i
                        className={`fas fa-chevron-${
                          sortDirection === "asc" ? "up" : "down"
                        }`}
                      />
                    )}
                    {sortedColumn !== "sugar" && (
                      <i className="fas fa-chevron-down fa-opac" />
                    )}
                  </th>
                  <th
                    className="text-center clickable"
                    title="Click to sort"
                    onClick={() => handleSort("price")}
                  >
                    Price Per Unit{" "}
                    {sortedColumn === "price" && (
                      <i
                        className={`fas fa-chevron-${
                          sortDirection === "asc" ? "up" : "down"
                        }`}
                      />
                    )}
                    {sortedColumn !== "price" && (
                      <i className="fas fa-chevron-down fa-opac" />
                    )}
                  </th>
                  <th
                    className="text-center clickable"
                    title="Click to sort"
                    onClick={() => handleSort("shopping_aisle")}
                  >
                    Aisle{" "}
                    {sortedColumn === "shopping_aisle" && (
                      <i
                        className={`fas fa-chevron-${
                          sortDirection === "asc" ? "up" : "down"
                        }`}
                      />
                    )}
                    {sortedColumn !== "shopping_aisle" && (
                      <i className="fas fa-chevron-down fa-opac" />
                    )}
                  </th>
                  <th
                    className="text-center clickable"
                    title="Click to sort"
                    onClick={() => handleSort("default_needs_prep")}
                  >
                    Needs Prep{" "}
                    <OverlayTrigger
                      delay={{ hide: 150, show: 150 }}
                      overlay={(props) => (
                        <Tooltip {...props}>
                          Mark ingredients that typically need to be chopped or prepped before use
                        </Tooltip>
                      )}
                      placement="top"
                    >
                      <FontAwesomeIcon
                        className="ms-1"
                        icon={faQuestionCircle}
                      />
                    </OverlayTrigger>
                    {sortedColumn === "default_needs_prep" && (
                      <i
                        className={`fas fa-chevron-${
                          sortDirection === "asc" ? "up" : "down"
                        } ms-1`}
                      />
                    )}
                    {sortedColumn !== "default_needs_prep" && (
                      <i className="fas fa-chevron-down fa-opac ms-1" />
                    )}
                  </th>
                  <th className="text-center">
                    Mass Update
                    <OverlayTrigger
                      delay={{ hide: 150, show: 150 }}
                      overlay={(props) => (
                        <Tooltip {...props}>
                          Update prep flag for this ingredient in ALL your recipes at once
                        </Tooltip>
                      )}
                      placement="top"
                    >
                      <FontAwesomeIcon
                        className="ms-1"
                        icon={faQuestionCircle}
                      />
                    </OverlayTrigger>
                  </th>
                  <th className="text-center">Edit</th>
                  <th className="text-center">Hide</th>
                </tr>
              </thead>
              <tbody>
                {filteredIngredients
                  .slice(startIndex, endIndex)
                  .map((ingredient) => (
                    <tr key={ingredient.id}>
                      <td>
                        {ingredient.id.toLowerCase().includes("user")
                          ? ingredient.ingredient_name
                          : `${ingredient.ingredient_name} (D)`}
                      </td>
                      <td className="text-center">{ingredient.unit_id}</td>
                      <td className="text-center">
                        {Number.isInteger(ingredient.calories)
                          ? parseFloat(ingredient.calories).toFixed(0)
                          : parseFloat(ingredient.calories).toFixed(1)}
                      </td>
                      <td className="text-center">
                        {" "}
                        {Number.isInteger(ingredient.protein)
                          ? parseFloat(ingredient.protein).toFixed(0)
                          : parseFloat(ingredient.protein).toFixed(1)}
                      </td>
                      <td className="text-center">
                        {" "}
                        {Number.isInteger(ingredient.carbs)
                          ? parseFloat(ingredient.carbs).toFixed(0)
                          : parseFloat(ingredient.carbs).toFixed(1)}
                      </td>
                      <td className="text-center">
                        {" "}
                        {Number.isInteger(ingredient.fat)
                          ? parseFloat(ingredient.fat).toFixed(0)
                          : parseFloat(ingredient.fat).toFixed(1)}
                      </td>
                      <td className="text-center">
                        {" "}
                        {Number.isInteger(ingredient.fiber)
                          ? parseFloat(ingredient.fiber).toFixed(0)
                          : parseFloat(ingredient.fiber).toFixed(1)}
                      </td>
                      <td className="text-center">
                        {" "}
                        {Number.isInteger(ingredient.sugar)
                          ? parseFloat(ingredient.sugar).toFixed(0)
                          : parseFloat(ingredient.sugar).toFixed(1)}
                      </td>
                      <td className="text-center">${ingredient.price}</td>
                      <td className="text-center">
                        {ingredient.shopping_aisle}
                      </td>
                      <td className="text-center">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={ingredient.default_needs_prep === 1}
                          onChange={() => handlePrepFlagToggle(ingredient)}
                        />
                      </td>
                      <td className="text-center">
                        <button
                          className="btn btn-sm btn-warning"
                          onClick={() => handleMassUpdateClick(ingredient)}
                        >
                          Update All
                        </button>
                      </td>
                      <td className="text-center">
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={() => handleSelectIngredient(ingredient)}
                        >
                          Edit
                        </button>
                      </td>
                      <td className="text-center">
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => handleHideIngredient(ingredient)}
                        >
                          Hide
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
        {/* -------------------- */}
        {/* Add Ingredient Modal */}
        {/* -------------------- */}
        <Modal show={showNewModal} onHide={handleAddCloseModal} size="lg" className="ingredient-modal">
          <ModalHeader closeButton>
            <ModalTitle>Add New Ingredient</ModalTitle>
          </ModalHeader>
          <ModalBody>
            <Tabs 
              defaultActiveKey="basic" 
              className="mb-3"
              style={{ 
                '--bs-nav-tabs-link-active-color': '#212529',
                '--bs-nav-tabs-link-active-bg': '#fff',
                '--bs-nav-link-color': '#495057',
                '--bs-nav-link-hover-color': '#212529'
              }}
            >
              <Tab eventKey="basic" title="Basic Information">
                <div className="section-header mb-3">
                  <p className="text-muted small mb-0">Required fields for ingredient identification</p>
                </div>
                <Alert variant="info" className="mb-3">
                  <i className="fas fa-info-circle me-2"></i>
                  <strong>Important:</strong> Once an ingredient is saved, its base unit cannot be changed. Choose carefully!
                </Alert>
                <div className="basic-info-section">
                  <div className="mb-3">
                    <label htmlFor="add-ingredient-name" className="form-label">
                      Ingredient Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter new ingredient name"
                      value={newIngredientName}
                      onChange={handleNewIngredientNameChange}
                      maxLength={100}
                    />
                    <Form.Text className="text-muted">
                      {newIngredientName.length}/100 characters
                    </Form.Text>
                  </div>
                  <div className="row">
                    <div className="mb-3 col-md-6">
                      <label htmlFor="add-base-unit" className="form-label">
                        Base Unit of Measurement <span className="text-danger">*</span>
                        <OverlayTrigger
                          placement="right"
                          overlay={
                            <Tooltip>
                              The primary unit for storing this ingredient. This cannot be changed after creation.
                            </Tooltip>
                          }
                        >
                          <FontAwesomeIcon icon={faQuestionCircle} className="ms-1 text-muted" />
                        </OverlayTrigger>
                      </label>
                      <div className="d-flex gap-2">
                        <div className="flex-grow-1">
                          <Select
                            options={unitOptions}
                            value={unitOptions.find(
                              (unit) => unit.unit_id === newUnitOfMeasurement
                            )}
                            onChange={(selectedOption) => {
                              if (selectedOption.unit_id.startsWith("D")) {
                                const unitId = parseInt(selectedOption.unit_id.substring(1));
                                setNewUnitOfMeasurement(unitId);
                                SetNewUnitOfMeasurementLabel(selectedOption.unit_name);
                                setNewCustomUnitFlag(0);
                                // Set pricing unit to match base unit by default
                                setNewPricingUnit(unitId);
                                setNewPricingUnitLabel(selectedOption.unit_name);
                              } else {
                                setNewUnitOfMeasurement(selectedOption.unit_id);
                                SetNewUnitOfMeasurementLabel(selectedOption.unit_name);
                                setNewCustomUnitFlag(1);
                                // Set pricing unit to match base unit by default
                                setNewPricingUnit(selectedOption.unit_id);
                                setNewPricingUnitLabel(selectedOption.unit_name);
                              }
                            }}
                            getOptionLabel={(option) => option.unit_name}
                            getOptionValue={(option) => option.unit_id}
                            isSearchable={true}
                            placeholder="Select a unit..."
                          />
                        </div>
                        <Button 
                          variant="outline-primary" 
                          size="sm"
                          onClick={() => setShowQuickUnitModal(true)}
                          style={{ height: '38px' }}
                        >
                          <FontAwesomeIcon icon={faPlus} className="me-1" /> New
                        </Button>
                      </div>
                      <Form.Text className="text-warning">
                        <i className="fas fa-exclamation-triangle"></i> Cannot be changed after saving
                      </Form.Text>
                    </div>
                    <div className="mb-3 col-md-6">
                      <label htmlFor="add-shopping-aisle" className="form-label">
                        Shopping Aisle
                        <OverlayTrigger
                          placement="right"
                          overlay={
                            <Tooltip>
                              Where to find this ingredient in the store. Helps organize your shopping list.
                            </Tooltip>
                          }
                        >
                          <FontAwesomeIcon icon={faQuestionCircle} className="ms-1 text-muted" />
                        </OverlayTrigger>
                      </label>
                      <Select
                        options={shoppingOptions}
                        value={shoppingOptions.find(
                          (aisle) => aisle.id === newShoppingAisle
                        )}
                        onChange={(selectedOption) => {
                          setNewShoppingAisle(selectedOption.id);
                        }}
                        getOptionLabel={(option) => option.aisle_name}
                        getOptionValue={(option) => option.id}
                        isSearchable={true}
                        placeholder="Select an aisle..."
                      />
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-md-6">
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="add-default-needs-prep"
                          checked={newDefaultNeedsPrep}
                          onChange={(e) => {
                            setNewDefaultNeedsPrep(e.target.checked);
                            if (!e.target.checked) {
                              setNewDefaultPrepType('chop');
                            }
                          }}
                        />
                        <label className="form-check-label" htmlFor="add-default-needs-prep">
                          Typically needs to be prepped
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip>
                                Check this if the ingredient typically requires preparation before use in recipes.
                              </Tooltip>
                            }
                          >
                            <FontAwesomeIcon icon={faQuestionCircle} className="ms-2 text-muted" />
                          </OverlayTrigger>
                        </label>
                      </div>
                    </div>
                    {newDefaultNeedsPrep && (
                      <div className="col-md-6">
                        <Select
                          options={[
                            { value: 'chop', label: 'Chop' },
                            { value: 'mix', label: 'Mix' },
                            { value: 'measure', label: 'Measure' },
                            { value: 'other', label: 'Other' }
                          ]}
                          value={{ value: newDefaultPrepType, label: newDefaultPrepType.charAt(0).toUpperCase() + newDefaultPrepType.slice(1) }}
                          onChange={(selectedOption) => setNewDefaultPrepType(selectedOption.value)}
                          isSearchable={false}
                          placeholder="Select prep type..."
                        />
                      </div>
                    )}
                  </div>
                </div>
              </Tab>
              
              <Tab eventKey="nutrition" title="Nutrition">
                <div className="section-header mb-3">
                  <p className="text-muted small mb-0">Nutritional information per base unit</p>
                </div>
                <div className="nutrition-grid">
                  <div className="row">
                    <div className="col-md-4 mb-3">
                      <div className="nutrition-field p-3 bg-light rounded">
                        <label htmlFor="add-new-protein" className="form-label">
                          Protein (g)
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="add-new-protein"
                          min="0"
                          step="0.1"
                          placeholder="0.0"
                          value={newProtein}
                          onChange={(e) =>
                            handleNewProteinChange(parseFloat(e.target.value))
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-4 mb-3">
                      <div className="nutrition-field p-3 bg-light rounded">
                        <label htmlFor="add-new-carbs" className="form-label">
                          Carbs (g)
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="add-new-carbs"
                          min="0"
                          step="0.1"
                          placeholder="0.0"
                          value={newCarbs}
                          onChange={(e) =>
                            handleNewCarbsChange(parseFloat(e.target.value))
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-4 mb-3">
                      <div className="nutrition-field p-3 bg-light rounded">
                        <label htmlFor="add-new-fat" className="form-label">
                          Fat (g)
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="add-new-fat"
                          min="0"
                          step="0.1"
                          placeholder="0.0"
                          value={newFat}
                          onChange={(e) =>
                            handleNewFatChange(parseFloat(e.target.value))
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-4 mb-3">
                      <div className="nutrition-field p-3 bg-light rounded">
                        <label htmlFor="add-new-fiber" className="form-label">
                          Fiber (g)
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="add-new-fiber"
                          min="0"
                          step="0.1"
                          placeholder="0.0"
                          value={newFiber}
                          onChange={(e) =>
                            handleNewFiberChange(parseFloat(e.target.value))
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-4 mb-3">
                      <div className="nutrition-field p-3 bg-light rounded">
                        <label htmlFor="add-new-sugar" className="form-label">
                          Sugar (g)
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="add-new-sugar"
                          min="0"
                          step="0.1"
                          placeholder="0.0"
                          value={newSugar}
                          onChange={(e) =>
                            handleNewSugarChange(parseFloat(e.target.value))
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-4 mb-3">
                      <div className="nutrition-field p-3 bg-light rounded">
                        <label className="form-label text-muted">
                          Calculated Calories
                        </label>
                        <div className="calculated-calories fw-bold">
                          {((newProtein || 0) * 4 + (newCarbs || 0) * 4 + (newFat || 0) * 9).toFixed(1)} cal
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab>
              
              <Tab eventKey="pricing" title="Pricing">
                <div className="section-header mb-3">
                  <p className="text-muted small mb-0">Set your store pricing to calculate unit cost</p>
                </div>
                <div className="price-calculator p-3 bg-light rounded">
                  <div className="row g-3">
                    {/* Unit Selection - Compact */}
                    <div className="col-12">
                      <label className="form-label small mb-1">Pricing Unit</label>
                      <Select
                        options={[
                          {
                            unit_id: newUnitOfMeasurement,
                            unit_name: newUnitOfMeasurementLabel || "Base Unit"
                          }
                        ]}
                        value={{
                          unit_id: newPricingUnit || newUnitOfMeasurement,
                          unit_name: newPricingUnitLabel || newUnitOfMeasurementLabel || "Base Unit"
                        }}
                        onChange={(selectedOption) => {
                          setNewPricingUnit(selectedOption.unit_id);
                          setNewPricingUnitLabel(selectedOption.unit_name);
                          // Recalculate price with new unit
                          const calculatedPrice = calculatePricePerBaseUnit(
                            newPrice, 
                            newStoreAmount, 
                            selectedOption.unit_id, 
                            newUnitOfMeasurement
                          );
                          setNewCalculatedPrice(calculatedPrice);
                        }}
                        getOptionLabel={(option) => option.unit_name}
                        getOptionValue={(option) => option.unit_id}
                        isSearchable={false}
                        isDisabled={!newUnitOfMeasurement}
                        placeholder="Select pricing unit..."
                        className="form-select-sm"
                      />
                    </div>
                    
                    {/* Package Size */}
                    <div className="col-6">
                      <label className="form-label small mb-1">Package Size</label>
                      <div className="input-group input-group-sm">
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Amount"
                          min="0"
                          step="0.1"
                          value={newStoreAmount}
                          onChange={handleNewStoreBaseAmountChange}
                        />
                        <span className="input-group-text">
                          {newPricingUnitLabel || newUnitOfMeasurementLabel || "units"}
                        </span>
                      </div>
                    </div>
                    
                    {/* Store Price */}
                    <div className="col-6">
                      <label className="form-label small mb-1">Store Price</label>
                      <div className="input-group input-group-sm">
                        <span className="input-group-text">$</span>
                        <input
                          type="number"
                          className="form-control"
                          placeholder="0.00"
                          min="0"
                          step="0.01"
                          value={newPrice}
                          onChange={handleNewStorePriceAmountChange}
                        />
                      </div>
                    </div>
                  </div>
                  {newStoreAmount && newPrice && (
                    <div className="calculated-result mt-2 p-2 bg-white rounded border">
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="small text-muted">Unit Price:</span>
                        <strong className="text-primary">
                          ${newCalculatedPrice.toFixed(2)}/{newUnitOfMeasurementLabel || "unit"}
                        </strong>
                      </div>
                      {newPricingUnit && newPricingUnit !== newUnitOfMeasurement && (
                        <div className="text-muted" style={{ fontSize: '0.75rem' }}>
                          <i className="fas fa-exchange-alt me-1"></i>
                          ${(newPrice / newStoreAmount).toFixed(2)}/{newPricingUnitLabel}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </Tab>
            </Tabs>
          </ModalBody>
          <Modal.Footer className="d-flex justify-content-between">
            <div></div>
            <div>
              <Button variant="secondary" onClick={handleAddCloseModal} className="me-2">
                Cancel
              </Button>
              <Button variant="primary" onClick={handleAddIngredient}>
                Save Ingredient
              </Button>
            </div>
          </Modal.Footer>
        </Modal>

        {/* Quick Unit Creator Modal */}
        <QuickUnitCreator 
          show={showQuickUnitModal}
          onHide={() => setShowQuickUnitModal(false)}
          onUnitCreated={(newUnit) => {
            // Refresh unit options
            fetch(`${process.env.REACT_APP_API_URL}/units`, {
              credentials: "include",
            })
              .then((response) => response.json())
              .then((data) => {
                setUnitOptions(data);
                // Set the new unit as selected
                if (newUnit.unit_source === "User") {
                  setNewUnitOfMeasurement(newUnit.unit_id);
                  SetNewUnitOfMeasurementLabel(newUnit.unit_name);
                  setNewCustomUnitFlag(1);
                  // Set pricing unit to match
                  setNewPricingUnit(newUnit.unit_id);
                  setNewPricingUnitLabel(newUnit.unit_name);
                }
              })
              .catch((error) => console.error("Error retrieving units:", error));
          }}
          defaultType="metric"
        />

        {/* --------------------- */}
        {/* Edit Ingredient Modal */}
        {/* --------------------- */}
        <Modal
          show={selectedIngredient !== null}
          onHide={() => setSelectedIngredient(null)}
          size="lg"
          className="ingredient-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Edit Ingredient
              {selectedIngredient && !selectedIngredient.id.includes("user") && (
                <span className="badge bg-info ms-2">System Ingredient</span>
              )}
              {selectedIngredient && selectedIngredient.id.includes("user") && (
                <span className="badge bg-success ms-2">Custom Ingredient</span>
              )}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Tabs 
              defaultActiveKey="basic" 
              className="mb-3"
              style={{ 
                '--bs-nav-tabs-link-active-color': '#212529',
                '--bs-nav-tabs-link-active-bg': '#fff',
                '--bs-nav-link-color': '#495057',
                '--bs-nav-link-hover-color': '#212529'
              }}
            >
              <Tab eventKey="basic" title="Basic Information">
                <div className="section-header mb-3">
                  <p className="text-muted small mb-0">Edit ingredient details and settings</p>
                </div>
                {selectedIngredient && !selectedIngredient.id.includes("user") && (
                  <Alert variant="info" className="mb-3">
                    <i className="fas fa-info-circle me-2"></i>
                    System ingredients have limited editing capabilities. You can customize pricing and shopping information.
                  </Alert>
                )}
                <div className="basic-info-section">
                  <div className="mb-3">
                    <label htmlFor="edit-ingredient-name" className="form-label">
                      Ingredient Name
                      {selectedIngredient && !selectedIngredient.id.includes("user") && (
                        <FontAwesomeIcon icon={faLock} className="ms-2 text-muted" />
                      )}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={editIngredientName}
                      onChange={handleEditIngredientNameChange}
                      disabled={
                        !selectedIngredient ||
                        !selectedIngredient.id.includes("user")
                      }
                      maxLength={100}
                    />
                    {selectedIngredient && selectedIngredient.id.includes("user") && (
                      <Form.Text className="text-muted">
                        {editIngredientName.length}/100 characters
                      </Form.Text>
                    )}
                    {selectedIngredient && !selectedIngredient.id.includes("user") && (
                      <Form.Text className="text-muted">
                        <i className="fas fa-lock"></i> System ingredients cannot be renamed
                      </Form.Text>
                    )}
                  </div>
                  <div className="row">
                    <div className="mb-3 col-md-6">
                      <label htmlFor="edit-base-unit" className="form-label">
                        Base Unit of Measurement
                        <FontAwesomeIcon icon={faLock} className="ms-2 text-muted" />
                        <OverlayTrigger
                          placement="right"
                          overlay={
                            <Tooltip>
                              The base unit cannot be changed after an ingredient is created. This ensures recipe consistency.
                            </Tooltip>
                          }
                        >
                          <FontAwesomeIcon icon={faQuestionCircle} className="ms-1 text-muted" />
                        </OverlayTrigger>
                      </label>
                      <Select
                        options={unitOptions}
                        value={{
                          unit_id: editUnitOfMeasurementId,
                          unit_name: editUnitOfMeasurement,
                        }}
                        onChange={(selectedOption) => {
                          if (selectedOption.unit_id.startsWith("D")) {
                            setEditUnitOfMeasurementId(
                              parseInt(selectedOption.unit_id.substring(1))
                            );
                            setEditUnitOfMeasurement(selectedOption.unit_name);
                            setEditCustomUnitFlag(0);
                          } else {
                            setEditUnitOfMeasurementId(selectedOption.unit_id);
                            setEditUnitOfMeasurement(selectedOption.unit_name);
                            setEditCustomUnitFlag(1);
                          }
                        }}
                        getOptionLabel={(option) => option.unit_name}
                        getOptionValue={(option) => option.unit_id}
                        isSearchable={true}
                        isDisabled={true}
                      />
                      <Form.Text className="text-warning">
                        <i className="fas fa-lock"></i> Base unit is permanent and cannot be changed
                      </Form.Text>
                    </div>
                    <div className="mb-3 col-md-6">
                      <label htmlFor="edit-shopping-aisle" className="form-label">
                        Shopping Aisle
                      </label>
                      <Select
                        options={shoppingOptions}
                        value={{
                          aisle_name: editShoppingAisle,
                          id: editShoppingAisleId,
                        }}
                        onChange={(selectedOption) => {
                          setEditShoppingAisleId(selectedOption.id);
                          setEditShoppingAisle(selectedOption.aisle_name);
                        }}
                        getOptionLabel={(option) => option.aisle_name}
                        getOptionValue={(option) => option.id}
                        isSearchable={true}
                      />
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-md-6">
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="edit-default-needs-prep"
                          checked={editDefaultNeedsPrep}
                          onChange={(e) => {
                            setEditDefaultNeedsPrep(e.target.checked);
                            if (!e.target.checked) {
                              setEditDefaultPrepType('chop');
                            }
                          }}
                        />
                        <label className="form-check-label" htmlFor="edit-default-needs-prep">
                          Typically needs to be prepped
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip>
                                Check this if the ingredient typically requires preparation before use in recipes.
                              </Tooltip>
                            }
                          >
                            <FontAwesomeIcon icon={faQuestionCircle} className="ms-2 text-muted" />
                          </OverlayTrigger>
                        </label>
                      </div>
                    </div>
                    {editDefaultNeedsPrep && (
                      <div className="col-md-6">
                        <Select
                          options={[
                            { value: 'chop', label: 'Chop' },
                            { value: 'mix', label: 'Mix' },
                            { value: 'measure', label: 'Measure' },
                            { value: 'other', label: 'Other' }
                          ]}
                          value={{ value: editDefaultPrepType, label: editDefaultPrepType.charAt(0).toUpperCase() + editDefaultPrepType.slice(1) }}
                          onChange={(selectedOption) => setEditDefaultPrepType(selectedOption.value)}
                          isSearchable={false}
                          placeholder="Select prep type..."
                        />
                      </div>
                    )}
                  </div>
                </div>
              </Tab>
              
              <Tab eventKey="nutrition" title="Nutrition">
                <div className="section-header mb-3">
                  <p className="text-muted small mb-0">Nutritional information per base unit</p>
                </div>
                {selectedIngredient && !selectedIngredient.id.includes("user") && (
                  <Alert variant="info" className="mb-3">
                    <i className="fas fa-info-circle me-2"></i>
                    Nutrition values are read-only for system ingredients.
                  </Alert>
                )}
                <div className="nutrition-grid">
                  <div className="row">
                    <div className="col-md-4 mb-3">
                      <div className="nutrition-field p-3 bg-light rounded">
                        <label htmlFor="edit-new-protein" className="form-label">
                          Protein (g)
                          {selectedIngredient && !selectedIngredient.id.includes("user") && (
                            <FontAwesomeIcon icon={faLock} className="ms-2 text-muted" />
                          )}
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="edit-new-protein"
                          min="0"
                          step="0.1"
                          value={editProtein !== null ? editProtein : ""}
                          onChange={(e) =>
                            handleEditProteinChange(parseFloat(e.target.value))
                          }
                          disabled={
                            !selectedIngredient ||
                            !selectedIngredient.id.includes("user")
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-4 mb-3">
                      <div className="nutrition-field p-3 bg-light rounded">
                        <label htmlFor="edit-new-carbs" className="form-label">
                          Carbs (g)
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="edit-new-carbs"
                          min="0"
                          step="0.1"
                          value={editCarbs !== null ? editCarbs : ""}
                          onChange={(e) =>
                            handleEditCarbsChange(parseFloat(e.target.value))
                          }
                          disabled={
                            !selectedIngredient ||
                            !selectedIngredient.id.includes("user")
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-4 mb-3">
                      <div className="nutrition-field p-3 bg-light rounded">
                        <label htmlFor="edit-new-fat" className="form-label">
                          Fat (g)
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="edit-new-fat"
                          min="0"
                          step="0.1"
                          value={editFat !== null ? editFat : ""}
                          onChange={(e) =>
                            handleEditFatChange(parseFloat(e.target.value))
                          }
                          disabled={
                            !selectedIngredient ||
                            !selectedIngredient.id.includes("user")
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-4 mb-3">
                      <div className="nutrition-field p-3 bg-light rounded">
                        <label htmlFor="edit-new-fiber" className="form-label">
                          Fiber (g)
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="edit-new-fiber"
                          min="0"
                          step="0.1"
                          value={editFiber !== null ? editFiber : ""}
                          onChange={(e) =>
                            handleEditFiberChange(parseFloat(e.target.value))
                          }
                          disabled={
                            !selectedIngredient ||
                            !selectedIngredient.id.includes("user")
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-4 mb-3">
                      <div className="nutrition-field p-3 bg-light rounded">
                        <label htmlFor="edit-new-sugar" className="form-label">
                          Sugar (g)
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="edit-new-sugar"
                          min="0"
                          step="0.1"
                          value={editSugar !== null ? editSugar : ""}
                          onChange={(e) =>
                            handleEditSugarChange(parseFloat(e.target.value))
                          }
                          disabled={
                            !selectedIngredient ||
                            !selectedIngredient.id.includes("user")
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-4 mb-3">
                      <div className="nutrition-field p-3 bg-light rounded">
                        <label className="form-label text-muted">
                          Calculated Calories
                        </label>
                        <div className="calculated-calories fw-bold">
                          {((editProtein || 0) * 4 + (editCarbs || 0) * 4 + (editFat || 0) * 9).toFixed(1)} cal
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab>
              
              <Tab eventKey="pricing" title="Pricing">
                <div className="section-header mb-3">
                  <p className="text-muted small mb-0">Update your store pricing to calculate unit cost</p>
                </div>
                <div className="price-calculator p-3 bg-light rounded">
                  <div className="row g-3">
                    {/* Unit Selection - Compact */}
                    <div className="col-12">
                      <label className="form-label small mb-1">Pricing Unit</label>
                      <Select
                        options={getAvailablePricingUnits(
                          editUnitOfMeasurementId,
                          editUnitOfMeasurement,
                          ingredientConversionList
                        )}
                        value={{
                          unit_id: editPricingUnit || editUnitOfMeasurementId,
                          unit_name: editPricingUnitLabel || editUnitOfMeasurement || "Base Unit"
                        }}
                        onChange={(selectedOption) => {
                          setEditPricingUnit(selectedOption.unit_id);
                          setEditPricingUnitLabel(selectedOption.unit_name);
                          // Recalculate price with new unit
                          const calculatedPrice = calculatePricePerBaseUnit(
                            editPrice, 
                            editStoreAmount, 
                            selectedOption.unit_id, 
                            editUnitOfMeasurementId
                          );
                          setEditCalculatedPrice(calculatedPrice);
                        }}
                        getOptionLabel={(option) => option.unit_name}
                        getOptionValue={(option) => option.unit_id}
                        isSearchable={false}
                        placeholder="Select pricing unit..."
                        className="form-select-sm"
                      />
                    </div>
                    
                    {/* Package Size */}
                    <div className="col-6">
                      <label className="form-label small mb-1">Package Size</label>
                      <div className="input-group input-group-sm">
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Amount"
                          min="0"
                          step="0.1"
                          value={editStoreAmount !== null ? editStoreAmount : ""}
                          onChange={handleEditStoreBaseAmountChange}
                        />
                        <span className="input-group-text">
                          {editPricingUnitLabel || editUnitOfMeasurement || "units"}
                        </span>
                      </div>
                    </div>
                    
                    {/* Store Price */}
                    <div className="col-6">
                      <label className="form-label small mb-1">Store Price</label>
                      <div className="input-group input-group-sm">
                        <span className="input-group-text">$</span>
                        <input
                          type="number"
                          className="form-control"
                          placeholder="0.00"
                          min="0"
                          step="0.01"
                          value={editPrice !== null ? editPrice : ""}
                          onChange={handleEditStorePriceAmountChange}
                        />
                      </div>
                    </div>
                  </div>
                  {editStoreAmount && editPrice && (
                    <div className="calculated-result mt-2 p-2 bg-white rounded border">
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="small text-muted">Unit Price:</span>
                        <strong className="text-primary">
                          ${editCalculatedPrice.toFixed(2)}/{editUnitOfMeasurement || "unit"}
                        </strong>
                      </div>
                      {editPricingUnit && editPricingUnit !== editUnitOfMeasurementId && (
                        <div className="text-muted" style={{ fontSize: '0.75rem' }}>
                          <i className="fas fa-exchange-alt me-1"></i>
                          ${(editPrice / editStoreAmount).toFixed(2)}/{editPricingUnitLabel}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </Tab>
              
              <Tab eventKey="conversions" title="Unit Conversions">
                <div className="section-header mb-3">
                  <p className="text-muted small mb-0">Manage unit conversions for this ingredient</p>
                </div>
                <div className="conversion-section">
                  <div className="add-conversion-area p-3 bg-light rounded mb-4">
                    <h5>Add New Conversion</h5>
                    <div className="row align-items-center mb-3">
                      <div className="col-auto">
                        <Form.Switch
                          type="switch"
                          id="custom-switch"
                          label={"Inverse Mode"}
                          checked={inverseConversion}
                          onChange={handleToggleConversion}
                        />
                      </div>
                      <div className="col-auto">
                        <OverlayTrigger
                          delay={{ hide: 150, show: 150 }}
                          overlay={(props) => (
                            <Tooltip {...props}>
                              Toggle to switch the conversion direction for easier input
                            </Tooltip>
                          )}
                          placement="bottom"
                        >
                          <FontAwesomeIcon icon={faQuestionCircle} />
                        </OverlayTrigger>
                      </div>
                    </div>
                    <div className="row align-items-end">
                      <div className="col-md-4">
                        <label className="form-label">
                          Convert to:
                        </label>
                        <Select
                          options={unitOptions}
                          value={unitOptions.find(
                            (unit) => unit.unit_id === newUnitOfMeasurement
                          )}
                          onChange={(selectedOption) => {
                            if (selectedOption.unit_id.startsWith("D")) {
                              setNewUnitOfMeasurement(
                                parseInt(selectedOption.unit_id.substring(1))
                              );
                              setNewCustomUnitFlag(0);
                              setSelectedUnitOption(selectedOption.unit_name);
                            } else {
                              setNewUnitOfMeasurement(selectedOption.unit_id);
                              setNewCustomUnitFlag(1);
                              setSelectedUnitOption(selectedOption.unit_name);
                            }
                          }}
                          getOptionLabel={(option) => option.unit_name}
                          getOptionValue={(option) => option.unit_id}
                          isSearchable={true}
                          placeholder="Select unit..."
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">
                          {inverseConversion ? (
                            <>How many <b>{selectedUnitOption}</b> in 1 <b>{editUnitOfMeasurement}</b>?</>
                          ) : (
                            <>How many <b>{editUnitOfMeasurement}</b> in 1 <b>{selectedUnitOption}</b>?</>
                          )}
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          min="0"
                          step="0.001"
                          placeholder="Enter amount"
                          value={addConversionInput}
                          onChange={(e) =>
                            handleAddConversionInput(parseFloat(e.target.value))
                          }
                        />
                      </div>
                      <div className="col-md-2">
                        <Button variant="primary" onClick={handleAddUnitConversion} className="w-100">
                          Add
                        </Button>
                      </div>
                    </div>
                  </div>
                  
                  <h5>Existing Conversions</h5>
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th>Unit Conversion</th>
                          <th>Conversion Factor</th>
                          <th className="text-end">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {ingredientConversionList.length === 0 ? (
                          <tr>
                            <td colSpan="3" className="text-center text-muted">
                              No conversions added yet
                            </td>
                          </tr>
                        ) : (
                          ingredientConversionList.map((conversion) => (
                            <tr key={conversion.id}>
                              <td>{conversion.unit_name}</td>
                              <td>{conversion.conversion_factor}</td>
                              <td className="text-end">
                                {conversion.user_id !== 1 ? (
                                  <>
                                    <Button
                                      variant="outline-primary"
                                      size="sm"
                                      className="me-2"
                                      onClick={() => handleEditConversion(conversion)}
                                    >
                                      Edit
                                    </Button>
                                    <Button
                                      variant="outline-danger"
                                      size="sm"
                                      onClick={() => handleDeleteConversion(conversion)}
                                    >
                                      Delete
                                    </Button>
                                  </>
                                ) : (
                                  <span className="text-muted">System default</span>
                                )}
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Tab>
              
              <Tab eventKey="voice" title="Voice Alias">
                {selectedIngredient && (
                  <VoiceAliasTab
                    itemId={selectedIngredient.id.split(",")[0]}
                    itemType={selectedIngredient.id.includes("user") ? "user_ingredient" : "ingredient"}
                    itemName={selectedIngredient.ingredient_name}
                  />
                )}
              </Tab>
            </Tabs>
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-between">
            <div></div>
            <div>
              <Button variant="secondary" onClick={() => setSelectedIngredient(null)} className="me-2">
                Cancel
              </Button>
              <Button variant="primary" onClick={handleSaveIngredient}>
                Save Changes
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
        {/* --------------------- */}
        {/* Hide Ingredient Modal */}
        {/* --------------------- */}
        <Modal
          show={selectedIngredientToHide !== null}
          onHide={() => setSelectedIngredientToHide(null)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Confirm Hide Unit</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to hide this ingredient? Hidden ingredients
            are still shown in your existing recipes, but you will no longer see
            them in the dropdown when editing or adding ingredients.
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setSelectedIngredientToHide(null)}
            >
              Cancel
            </Button>
            <Button variant="danger" onClick={handleConfirmHideIngredient}>
              Hide
            </Button>
          </Modal.Footer>
        </Modal>
        {/* -------------------- */}
        {/* Unhide Ingredient Modal */}
        {/* -------------------- */}
        <Modal
          show={selectedIngredientToUnhide !== null}
          onHide={() => setSelectedIngredientToUnhide(null)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Confirm Hide Unit</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to unhide this ingredient?
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setSelectedIngredientToUnhide(null)}
            >
              Cancel
            </Button>
            <Button variant="danger" onClick={handleConfirmUnhideIngredient}>
              Hide
            </Button>
          </Modal.Footer>
        </Modal>
        {/* --------------------- */}
        {/* Edit Conversion Modal */}
        {/* --------------------- */}
        <Modal
          show={selectedConversionToEdit !== null}
          onHide={() => setSelectedConversionToEdit(null)}
          centered
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Edit Conversion</Modal.Title>
          </Modal.Header>
          <Modal.Body>


              <div className="row">
                <div
                  className="col"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Form.Switch
                    type="switch"
                    id="custom-switch"
                    label={"Inverse Conversion"}
                    checked={inverseConversion}
                    onChange={handleToggleConversion}
                  />{" "}
                  <OverlayTrigger
                    delay={{ hide: 150, show: 150 }}
                    overlay={(props) => (
                      <Tooltip {...props}>
                        Toggle this to change the conversion statement below to
                        make inputs easier. Eg, swithes "How many Serving(s) in
                        1x Cup(s)" to "How many Cup(s) in 1x Serving(s)".
                      </Tooltip>
                    )}
                    placement="bottom"
                  >
                    <FontAwesomeIcon className="mx-2" icon={faQuestionCircle} />
                  </OverlayTrigger>{" "}
                </div>
              </div>
              <div className="row">
                <div className="mb-3 col">
                <label htmlFor="add-base-unit" className="form-label">
                    Edit unit to convert to:
                  </label>
                  <Select
                    options={unitOptions}
                    value={{
                      unit_id: editConversionUnitOfMeasurementId,
                      unit_name: editConversionUnitOfMeasurement,
                    }}
                    onChange={(selectedOption) => {
                      if (selectedOption.unit_id.startsWith("D")) {
                        setEditConversionUnitOfMeasurementId(
                          parseInt(selectedOption.unit_id.substring(1))
                        );
                        setEditConversionUnitOfMeasurement(
                          selectedOption.unit_name
                        );
                        setEditConversionCustomUnitFlag(0);
                      } else {
                        setEditConversionUnitOfMeasurementId(
                          selectedOption.unit_id
                        );
                        setEditConversionUnitOfMeasurement(
                          selectedOption.unit_name
                        );
                        setEditConversionCustomUnitFlag(1);
                      }
                    }}
                    getOptionLabel={(option) => option.unit_name}
                    getOptionValue={(option) => option.unit_id}
                    isSearchable={true}
                  />
                </div>

                <div className="mb-3 col">
                                  
                  {inverseConversion ? (
                    <label
                      htmlFor="add-conversion-input"
                      className="form-label"
                    >
                      {/* Content when inverseConversion is true */}
                      How many <b>{editConversionUnitOfMeasurement}</b> in 1x{" "}
                      <b>{editUnitOfMeasurement}</b>
                    </label>
                  ) : (
                    <label
                      htmlFor="add-conversion-input"
                      className="form-label"
                    >
                      {/* Content when inverseConversion is false */}
                      How many <b>{editUnitOfMeasurement}</b> in 1x{" "}
                      <b>{editConversionUnitOfMeasurement}</b>
                    </label>
                  )}
                  <input
                    type="number"
                    className="form-control"
                    id="add-conversion-input"
                    min="0"
                    value={editConversionFactor}
                    onChange={(e) =>
                      handleEditConversionInput(parseFloat(e.target.value))
                    }
                  />
                </div>
              </div>

              <div className="mb-3 col-sm-2 d-flex align-items-end">
                <Button variant="primary" onClick={handleUpdateUnitConversion}>
                  Update
                </Button>
              </div>

          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setSelectedConversionToEdit(null)}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      </div>

      {/*
      -------------
      Hidden Units
    Hide and Unhide Option
    ----------
     */}

      <div>
        <h2>Hidden Ingredients</h2>
        <p>
          Hidden ingredients are still shown in existing recipes; however, they
          will not appear in the dropdown when customizing recipes.
        </p>
        <div className="row">
          <div className="col-sm-4 ">
            <label htmlFor="page-size-select" className="mr-2">
              Show:
            </label>{" "}
            <div className="btn-group mr-2">
              <button
                type="button"
                className="btn btn-sm btn-secondary dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                {hiddenPageSize}
              </button>
              <div className="dropdown-menu">
                <button
                  className="dropdown-item"
                  onClick={() => setHiddenPageSize(10)}
                >
                  10
                </button>
                <button
                  className="dropdown-item"
                  onClick={() => setHiddenPageSize(25)}
                >
                  25
                </button>
                <button
                  className="dropdown-item"
                  onClick={() => setHiddenPageSize(50)}
                >
                  50
                </button>
                <button
                  className="dropdown-item"
                  onClick={() => setHiddenPageSize(100)}
                >
                  100
                </button>
              </div>
            </div>
          </div>
          <div className="col-sm-4">
            <input
              type="text"
              className="form-control"
              placeholder="Search units"
              value={hiddenSearchQuery}
              onChange={(e) => setHiddenSearchQuery(e.target.value)}
            />
          </div>
          <div className="col-sm-4">
  <nav>
    <ul className="pagination justify-content-end">
      <li className={`page-item ${hiddenCurrentPage === 0 && "disabled"}`}>
        <button
          className="page-link"
          onClick={hiddenHandlePrevPage}
          disabled={hiddenCurrentPage === 0}
        >
          Previous
        </button>
      </li>
      {Array.from({ length: hiddenPagesCount }, (_, i) => {
        // Display only a subset of pages around the current page
        const maxPagesToShow = 5; // Adjust as needed
        const halfMaxPagesToShow = Math.floor(maxPagesToShow / 2);
        const startPage =
          hiddenCurrentPage <= halfMaxPagesToShow
            ? 0
            : Math.min(
                Math.max(hiddenCurrentPage - halfMaxPagesToShow, 0),
                hiddenPagesCount - maxPagesToShow
              );
        const endPage = Math.min(startPage + maxPagesToShow, hiddenPagesCount);

        if (i === startPage && startPage !== 0) {
          return (
            <li key="ellipsis-start" className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          );
        }

        if (i === endPage && endPage !== hiddenPagesCount) {
          return (
            <li key="ellipsis-end" className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          );
        }

        if (i >= startPage && i < endPage) {
          return (
            <li
              key={i}
              className={`page-item ${
                hiddenCurrentPage === i && "active"
              }`}
            >
              <button
                className="page-link"
                onClick={() => setHiddenCurrentPage(i)}
              >
                {i + 1}
              </button>
            </li>
          );
        }

        return null;
      })}
      <li
        className={`page-item ${
          hiddenCurrentPage === hiddenPagesCount - 1 && "disabled"
        }`}
      >
        <button
          className="page-link"
          onClick={hiddenHandleNextPage}
          disabled={hiddenCurrentPage === hiddenPagesCount - 1}
        >
          Next
        </button>
      </li>
    </ul>
  </nav>
</div>

        </div>
        <div className="table-responsive">
          <table className="table table-hover table-bordered table-striped">
            <thead>
              <tr>
                <th
                  className="text-center clickable"
                  title="Click to sort"
                  onClick={() => hiddenHandleSort("ingredient_name")}
                >
                  Ingredient{" "}
                  {hiddenSortedColumn === "ingredient_name" && (
                    <i
                      className={`fas fa-chevron-${
                        hiddenSortDirection === "asc" ? "up" : "down"
                      }`}
                    />
                  )}
                  {hiddenSortedColumn !== "ingredient_name" && (
                    <i className="fas fa-chevron-down fa-opac" />
                  )}
                </th>
                <th
                  className="text-center clickable"
                  title="Click to sort"
                  onClick={() => hiddenHandleSort("unit_id")}
                >
                  Base Unit{" "}
                  {hiddenSortedColumn === "unit_id" && (
                    <i
                      className={`fas fa-chevron-${
                        hiddenSortDirection === "asc" ? "up" : "down"
                      }`}
                    />
                  )}
                  {sortedColumn !== "unit_id" && (
                    <i className="fas fa-chevron-down fa-opac" />
                  )}
                </th>
                <th
                  className="text-center clickable"
                  title="Click to sort"
                  onClick={() => hiddenHandleSort("calories")}
                >
                  Calories{" "}
                  {hiddenSortedColumn === "calories" && (
                    <i
                      className={`fas fa-chevron-${
                        hiddenSortDirection === "asc" ? "up" : "down"
                      }`}
                    />
                  )}
                  {hiddenSortedColumn !== "calories" && (
                    <i className="fas fa-chevron-down fa-opac" />
                  )}
                </th>
                <th
                  className="text-center clickable"
                  title="Click to sort"
                  onClick={() => hiddenHandleSort("protein")}
                >
                  Protein{" "}
                  {hiddenSortedColumn === "protein" && (
                    <i
                      className={`fas fa-chevron-${
                        hiddenSortDirection === "asc" ? "up" : "down"
                      }`}
                    />
                  )}
                  {hiddenSortedColumn !== "protein" && (
                    <i className="fas fa-chevron-down fa-opac" />
                  )}
                </th>
                <th
                  className="text-center clickable"
                  title="Click to sort"
                  onClick={() => hiddenHandleSort("carbs")}
                >
                  Carbs{" "}
                  {hiddenSortedColumn === "carbs" && (
                    <i
                      className={`fas fa-chevron-${
                        hiddenSortDirection === "asc" ? "up" : "down"
                      }`}
                    />
                  )}
                  {hiddenSortedColumn !== "carbs" && (
                    <i className="fas fa-chevron-down fa-opac" />
                  )}
                </th>
                <th
                  className="text-center clickable"
                  title="Click to sort"
                  onClick={() => hiddenHandleSort("fat")}
                >
                  Fat{" "}
                  {hiddenSortedColumn === "fat" && (
                    <i
                      className={`fas fa-chevron-${
                        hiddenSortDirection === "asc" ? "up" : "down"
                      }`}
                    />
                  )}
                  {hiddenSortedColumn !== "fat" && (
                    <i className="fas fa-chevron-down fa-opac" />
                  )}
                </th>
                <th
                  className="text-center clickable"
                  title="Click to sort"
                  onClick={() => hiddenHandleSort("fiber")}
                >
                  Fiber{" "}
                  {hiddenSortedColumn === "fiber" && (
                    <i
                      className={`fas fa-chevron-${
                        hiddenSortDirection === "asc" ? "up" : "down"
                      }`}
                    />
                  )}
                  {hiddenSortedColumn !== "fiber" && (
                    <i className="fas fa-chevron-down fa-opac" />
                  )}
                </th>
                <th
                  className="text-center clickable"
                  title="Click to sort"
                  onClick={() => hiddenHandleSort("sugar")}
                >
                  Sugar{" "}
                  {hiddenSortedColumn === "sugar" && (
                    <i
                      className={`fas fa-chevron-${
                        hiddenSortDirection === "asc" ? "up" : "down"
                      }`}
                    />
                  )}
                  {hiddenSortedColumn !== "sugar" && (
                    <i className="fas fa-chevron-down fa-opac" />
                  )}
                </th>
                <th
                  className="text-center clickable"
                  title="Click to sort"
                  onClick={() => hiddenHandleSort("price")}
                >
                  Price Per Unit{" "}
                  {hiddenSortedColumn === "price" && (
                    <i
                      className={`fas fa-chevron-${
                        hiddenSortDirection === "asc" ? "up" : "down"
                      }`}
                    />
                  )}
                  {hiddenSortedColumn !== "price" && (
                    <i className="fas fa-chevron-down fa-opac" />
                  )}
                </th>
                <th
                  className="text-center clickable"
                  title="Click to sort"
                  onClick={() =>
                    hiddenHandleSort("shopping_aisleshopping_aisle")
                  }
                >
                  Aisle{" "}
                  {hiddenSortedColumn === "shopping_aisle" && (
                    <i
                      className={`fas fa-chevron-${
                        hiddenSortDirection === "asc" ? "up" : "down"
                      }`}
                    />
                  )}
                  {hiddenSortedColumn !== "shopping_aisle" && (
                    <i className="fas fa-chevron-down fa-opac" />
                  )}
                </th>
                <th className="text-center">Edit</th>
                <th className="text-center">Hide</th>
              </tr>
            </thead>
            <tbody>
              {hiddenFilteredIngredients
                .slice(hiddenStartIndex, hiddenEndIndex)
                .map((hiddenIngredient) => (
                  <tr key={hiddenIngredient.id}>
                    <td>
                      {hiddenIngredient.id.toLowerCase().includes("user")
                        ? hiddenIngredient.ingredient_name
                        : `${hiddenIngredient.ingredient_name} (D)`}
                    </td>
                    <td className="text-center">{hiddenIngredient.unit_id}</td>
                    <td className="text-center">
                      {Number.isInteger(hiddenIngredient.calories)
                        ? parseFloat(hiddenIngredient.calories).toFixed(0)
                        : parseFloat(hiddenIngredient.calories).toFixed(1)}
                    </td>
                    <td className="text-center">
                      {" "}
                      {Number.isInteger(hiddenIngredient.protein)
                        ? parseFloat(hiddenIngredient.protein).toFixed(0)
                        : parseFloat(hiddenIngredient.protein).toFixed(1)}
                    </td>
                    <td className="text-center">
                      {" "}
                      {Number.isInteger(hiddenIngredient.carbs)
                        ? parseFloat(hiddenIngredient.carbs).toFixed(0)
                        : parseFloat(hiddenIngredient.carbs).toFixed(1)}
                    </td>
                    <td className="text-center">
                      {" "}
                      {Number.isInteger(hiddenIngredient.fat)
                        ? parseFloat(hiddenIngredient.fat).toFixed(0)
                        : parseFloat(hiddenIngredient.fat).toFixed(1)}
                    </td>
                    <td className="text-center">
                      {" "}
                      {Number.isInteger(hiddenIngredient.fiber)
                        ? parseFloat(hiddenIngredient.fiber).toFixed(0)
                        : parseFloat(hiddenIngredient.fiber).toFixed(1)}
                    </td>
                    <td className="text-center">
                      {" "}
                      {Number.isInteger(hiddenIngredient.sugar)
                        ? parseFloat(hiddenIngredient.sugar).toFixed(0)
                        : parseFloat(hiddenIngredient.sugar).toFixed(1)}
                    </td>
                    <td className="text-center">${hiddenIngredient.price}</td>
                    <td className="text-center">
                      {hiddenIngredient.shopping_aisle}
                    </td>
                    <td className="text-center">
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={() => handleSelectIngredient(hiddenIngredient)}
                      >
                        Edit
                      </button>
                    </td>
                    <td className="text-center">
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => handleUnhideIngredient(hiddenIngredient)}
                      >
                        Unhide
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Mass Update Prep Flags Modal */}
      <Modal
        show={showMassUpdateModal}
        onHide={() => setShowMassUpdateModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Update All Recipes</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedIngredientForMassUpdate && (
            <>
              <p>
                You are about to update the prep flag for <strong>
                  {selectedIngredientForMassUpdate.ingredient_name}
                </strong> in ALL your recipes that contain this ingredient.
              </p>
              <div className="alert alert-warning">
                <strong>Warning:</strong> This will override any custom prep settings 
                you've set for this ingredient in individual recipes.
              </div>
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="mass-update-prep-value"
                  checked={massUpdatePrepValue}
                  onChange={(e) => setMassUpdatePrepValue(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="mass-update-prep-value">
                  This ingredient needs to be prepped (chopped, diced, etc.)
                </label>
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowMassUpdateModal(false)}>
            Cancel
          </Button>
          <Button variant="warning" onClick={handleMassUpdateConfirm}>
            Update All Recipes
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Ingredients;
